document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-violex-product-picker]').forEach((picker) => {
    const select = picker.querySelector('[data-violex-variant-select]');
    const sizeWrap = picker.querySelector('[data-violex-sizes]');
    const price = picker.querySelector('[data-violex-product-price]');
    const button = picker.querySelector('[data-violex-add-to-cart]');
    if (!select || !button) return;

    // Grössen-Buttons statt Dropdown (Doku/ux-audit-shop-und-giveaway.md
    // Abschnitt 5, Audit-Punkt 6) - aus genau denselben <option>s gebaut wie
    // das <select>, keine zweite Liste. Gleiches Muster wie
    // setupPicker()/vxe__sizes in violex-edition.js.
    if (sizeWrap) {
      Array.prototype.forEach.call(select.options, (option) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'violex-product-summary__size';
        btn.textContent = option.dataset.option1 || option.text;
        btn.dataset.value = option.value;
        btn.disabled = option.dataset.available !== 'true';
        btn.setAttribute('aria-pressed', option.selected ? 'true' : 'false');
        if (btn.disabled) {
          btn.setAttribute(
            'aria-label',
            (option.dataset.option1 || option.text) + ' — Ausverkauft',
          );
        }
        btn.addEventListener('click', () => {
          select.value = option.value;
          // 'change' feuern, damit derselbe Pfad laeuft wie bei einer
          // Bedienung des <select> selbst (Tastatur, ohne JS-Buttons).
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
        sizeWrap.appendChild(btn);
      });
    }

    const updateVariant = () => {
      const option = select.options[select.selectedIndex];
      const available = option && option.dataset.available === 'true';
      button.dataset.variantId = option?.value || '';
      button.disabled = !available;
      button.textContent = available
        ? button.dataset.defaultText || 'In den Warenkorb'
        : button.dataset.soldOutText || 'Ausverkauft';
      if (price && option?.dataset.price) price.textContent = option.dataset.price;
      if (sizeWrap) {
        sizeWrap.querySelectorAll('.violex-product-summary__size').forEach((btn) => {
          btn.setAttribute('aria-pressed', btn.dataset.value === select.value ? 'true' : 'false');
        });
      }
    };

    select.addEventListener('change', updateVariant);
    updateVariant();
  });

  document.querySelectorAll('[data-violex-add-to-cart]').forEach((button) => {
    button.addEventListener('click', async () => {
      if (button.disabled) return;
      const variantId = button.dataset.variantId;
      if (!variantId) return;
      const originalText = button.dataset.defaultText || button.textContent.trim();

      button.disabled = true;
      button.textContent = 'Wird hinzugefügt …';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        });

        const data = await res.json().catch(() => ({}));

        if (!res.ok) {
          throw new Error(data.description || 'Hinzufügen fehlgeschlagen');
        }

        button.textContent = 'Hinzugefügt ✓';
        // Volles Item statt nur der variantId: das Slide-in-Panel
        // (violex-cart-drawer.js) braucht Bild/Titel/Variante/Preis für die
        // Bestätigung und holt die NICHT selbst nach - /cart/add.js liefert
        // das im "items"-Wrapper-Format (oben) bereits mit.
        document.dispatchEvent(
          new CustomEvent('violex:cart:add', { detail: { variantId, item: data.items && data.items[0] } }),
        );
      } catch (_err) {
        button.textContent = 'Fehler – erneut versuchen';
      } finally {
        setTimeout(() => {
          button.textContent = originalText;
          const picker = button.closest('[data-violex-product-picker]');
          const select = picker?.querySelector('[data-violex-variant-select]');
          const option = select?.options[select.selectedIndex];
          button.disabled = option ? option.dataset.available !== 'true' : false;
        }, 1800);
      }
    });
  });
});
